import React, { useState, useRef, useEffect } from 'react';
import { HiBell } from 'react-icons/hi';
import { useNotificationCenter } from '../../context/NotificationContext';
import NotificationPanel from './NotificationPanel';

const NotificationBell = () => {
  const { unreadCount } = useNotificationCenter();
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  // Close panel on click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const displayCount = unreadCount > 9 ? '9+' : unreadCount;

  return (
    <div ref={wrapperRef} className="relative">
      <button
        onClick={() => setIsOpen(prev => !prev)}
        className="relative p-2 rounded-xl hover:bg-surface-100 transition-colors"
        aria-label={`Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ''}`}
      >
        <HiBell className={`text-xl ${unreadCount > 0 ? 'text-ink-700' : 'text-ink-400'}`} />
        {unreadCount > 0 && (
          <span className="absolute -top-0.5 -right-0.5 min-w-[1.25rem] h-5 flex items-center justify-center rounded-full bg-blush text-white text-[0.625rem] font-bold px-1">
            {displayCount}
          </span>
        )}
      </button>

      {isOpen && <NotificationPanel onClose={() => setIsOpen(false)} />}
    </div>
  );
};

export default NotificationBell;
